/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'ai-summary-label': 'Opsummer',
  'copy-content-link-label': 'Kopiér link',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'Begynd at skrive for at søge efter en etiket',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'Alle',
  'dynamic-cards-search-page.app-filter-sidebar.group': 'Filtrer søgning efter produkt',
  'dynamic-cards-search-page.app-filter-sidebar.group-appify': 'Filtrer søgning efter app',
  'dynamic-cards-search-page.atlas.for': 'for',
  'dynamic-cards-search-page.avatar': 'Avatar',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'Kalender',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'Deltag i mødet',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'Mødelink',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'Deltag i mødet',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': 'Tidligere hændelser',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': 'Tilbagevendende hændelse',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': 'Tilbagevendende',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': 'Kommende begivenheder',
  'dynamic-cards-search-page.compass.owner-name': 'Ejet af {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': 'Niveau {tier}',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'Find indhold',
  'dynamic-cards-search-page.confluence.filter.content.selected': 'Valgt',
  'dynamic-cards-search-page.confluence.filter.content.unselected': 'Foreslået',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': 'Valgt',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': 'Foreslået',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'Find personer',
  'dynamic-cards-search-page.confluence.filter.label.selected': 'Valgt',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'Find mærkater',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'Find områder',
  'dynamic-cards-search-page.connect_third_party_product_description':
    'Tilknyt din konto for at se manglende resultater',
  'dynamic-cards-search-page.connect_third_party_product_title': 'Din administrator har tilføjet {product}!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} er nu tilgængeligt!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': 'Startdatoen skal ligge før slutdatoen',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': 'Startdatoen må ikke ligge i fremtiden',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': 'Slutdatoen må ikke ligge i fremtiden',
  'dynamic-cards-search-page.date.filter.last.month': 'Inden for de seneste 30 dage',
  'dynamic-cards-search-page.date.filter.last.week': 'Inden for de seneste 7 dage',
  'dynamic-cards-search-page.date.filter.last.year': 'Det seneste år',
  'dynamic-cards-search-page.document-search-result.google-slides-label': 'Slides',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': 'Generér svar',
  'dynamic-cards-search-page.dropdown_recent_icon_label': 'Seneste',
  'dynamic-cards-search-page.error_primary': 'Vi har problemer med at søge',
  'dynamic-cards-search-page.error_secondary':
    'Det kan være et midlertidigt problem. Det bedste, du kan gøre, er at <btn>prøve igen</btn>.',
  'dynamic-cards-search-page.externalPeopleLabel': 'Eksterne personer #{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'Ryd filter',
  'dynamic-cards-search-page.filter.last.updated.anytime': 'Når som helst',
  'dynamic-cards-search-page.filter.last.updated.past30Days': 'Inden for de seneste 30 dage',
  'dynamic-cards-search-page.filter.last.updated.past7Days': 'Inden for de seneste 7 dage',
  'dynamic-cards-search-page.filter.last.updated.pastYear': 'Det seneste år',
  'dynamic-cards-search-page.filter.last.updated.today': 'I dag',
  'dynamic-cards-search-page.filter.last.updated.yesterday': 'I går',
  'dynamic-cards-search-page.filter.type.answer': 'Svar',
  'dynamic-cards-search-page.filter.type.attachment': 'Vedhæftninger',
  'dynamic-cards-search-page.filter.type.blogpost': 'Blogindlæg',
  'dynamic-cards-search-page.filter.type.branch': 'Grene',
  'dynamic-cards-search-page.filter.type.calendar': 'Kalendere',
  'dynamic-cards-search-page.filter.type.card': 'Kort',
  'dynamic-cards-search-page.filter.type.comment': 'Kommentarer',
  'dynamic-cards-search-page.filter.type.commit': 'Udførelser',
  'dynamic-cards-search-page.filter.type.component': 'Komponenter',
  'dynamic-cards-search-page.filter.type.conversation': 'Samtaler',
  'dynamic-cards-search-page.filter.type.database': 'Databaser',
  'dynamic-cards-search-page.filter.type.design': 'Design',
  'dynamic-cards-search-page.filter.type.documents': 'Dokumenter',
  'dynamic-cards-search-page.filter.type.embed': 'Intelligente links',
  'dynamic-cards-search-page.filter.type.issue': 'Sager',
  'dynamic-cards-search-page.filter.type.message': 'Beskeder',
  'dynamic-cards-search-page.filter.type.page': 'Sider',
  'dynamic-cards-search-page.filter.type.placeholder': 'Find type',
  'dynamic-cards-search-page.filter.type.presentation': 'Præsentationer',
  'dynamic-cards-search-page.filter.type.pull-request': 'Pullanmodninger',
  'dynamic-cards-search-page.filter.type.question': 'Spørgsmål',
  'dynamic-cards-search-page.filter.type.repository': 'Lagre',
  'dynamic-cards-search-page.filter.type.space': 'Områder',
  'dynamic-cards-search-page.filter.type.space-calendar': 'Områdekalendere',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'Regneark',
  'dynamic-cards-search-page.filter.type.video': 'Videoer',
  'dynamic-cards-search-page.filter.type.web-page': 'Websider',
  'dynamic-cards-search-page.filter.type.whiteboard': 'Whiteboards',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'Ryd alle',
  'dynamic-cards-search-page.filters.dropdown.title': 'Filter',
  'dynamic-cards-search-page.filters.names.content': 'Indhold under',
  'dynamic-cards-search-page.filters.names.contributor': 'Bidragyder',
  'dynamic-cards-search-page.filters.names.labels': 'Etiket',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'Titelmatch',
  'dynamic-cards-search-page.github-branch-result.label': 'Gren',
  'dynamic-cards-search-page.github-commit-result.label': 'Commit',
  'dynamic-cards-search-page.github-pull-request-result.label': 'Pullanmodning',
  'dynamic-cards-search-page.input_placeholder_search_only': 'Søg efter hvad som helst',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'Find projekter',
  'dynamic-cards-search-page.landing_primary': 'Kom godt i gang med filtre til dynamiske kort',
  'dynamic-cards-search-page.legacy-third-party-result.google-docs-label': 'Dokumenter',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'Ark',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': 'Vi kunne ikke finde noget, der matchede din søgning',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'Det lader til, at du anvender filtre. Du kan prøve at rydde dem.',
  'dynamic-cards-search-page.nouns.goal': 'Mål',
  'dynamic-cards-search-page.nouns.goals': 'Mål',
  'dynamic-cards-search-page.nouns.tag': 'Tag',
  'dynamic-cards-search-page.nouns.tags': 'Tags',
  'dynamic-cards-search-page.number_of_results': 'Viser {numberOfResults,number} af {totalCount,number} resultater',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': 'Godkendelse til {product} mislykkedes.',
  'dynamic-cards-search-page.oauth-banner.authorization-success': 'Godkendelse til {product} lykkedes.',
  'dynamic-cards-search-page.oauth-message-connect': 'Forbind',
  'dynamic-cards-search-page.products.custom-website': 'Webside',
  'dynamic-cards-search-page.results-sort.createdDate.selected': 'Sortér efter oprettet (nyeste)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': 'Oprettet (nyeste)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': 'Opdateret (nyeste)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': 'Sortér efter opdateret (nyeste)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'Skift listesortering',
  'dynamic-cards-search-page.rovo-onboarding-next': 'Næste',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    'Filtrer efter produkt for at få mere relevante søgeresultater.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description-appify':
    'Filtrer efter app for at få mere relevante søgeresultater.',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': 'Søg på tværs af alle virksomhedens arbejdsområder',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    'Afhængigt af det produkt, du filtrerer efter, ændres disse indstillinger for at hjælpe dig med at få specifikke resultater.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description-appify':
    'Afhængigt af den app, du filtrerer efter, ændres disse indstillinger for at hjælpe dig med at få specifikke resultater.',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': 'Find præcis, hvad du leder efter',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': 'Vedhæftning',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': 'Vedhæftet {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': 'Lyd',
  'dynamic-cards-search-page.search-result.attachments.image-label': 'Billede',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': 'Opdateret: {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': 'Privat kanal',
  'dynamic-cards-search-page.search-result.remove-recent-search': 'Fjern ikon for seneste søgning',
  'dynamic-cards-search-page.search-result.repository-label': 'Lager',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {Gruppemeddelelse med eksterne brugere} =2 {{name1} og {name2}} =3 {{name1}, {name2} og {name3}} =4 {{name1}, {name2}, {name3} og {overflowContributorCount} andre} one {{name1}} other {{name1}, {name2}, {name3} og {overflowContributorCount} andre}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': 'ukendt-kanal',
  'dynamic-cards-search-page.search_result_type_answer': 'Svar',
  'dynamic-cards-search-page.search_result_type_comment': 'Kommenter',
  'dynamic-cards-search-page.search_result_type_commit': 'Udfør',
  'dynamic-cards-search-page.search_result_type_component': 'Komponent',
  'dynamic-cards-search-page.search_result_type_document': 'Dokument',
  'dynamic-cards-search-page.search_result_type_embed': 'Intelligent link',
  'dynamic-cards-search-page.search_result_type_folder': 'Mappe',
  'dynamic-cards-search-page.search_result_type_presentation': 'Præsentation',
  'dynamic-cards-search-page.search_result_type_pull_request': 'Pullanmodning',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'SharePoint-dokument',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'Områdekalender',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'Regneark',
  'dynamic-cards-search-page.search_result_type_unrecognised': 'Ikke genkendt',
  'dynamic-cards-search-page.search_result_type_work_item': 'Sag',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    'Din administrator har tilføjet <strong>{product}!</strong>{br} Forbind din konto for at se manglende resultater, herunder dokumenter, som kun du har adgang til.',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} er nu tilgængeligt!</strong>{br} Forbind din konto for at se manglende resultater, herunder dokumenter, som kun du har adgang til.',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': 'Godkend',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': 'Godkendelse til {product} mislykkedes.',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': 'Godkendelse til {product} lykkedes.',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'Filtrer efter alle apps',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': 'Filtrer efter flere apps',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'Arkiveret',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'I risikozonen',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'Annulleret',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': 'Gennemført',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': 'Holder ikke tidsplanen',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': 'Holder tidsplanen',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': 'Midlertidig stoppet',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': 'Afventer',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, one {{chapterCount,number} kapitel i denne video} other {{chapterCount,number} kapitler i denne video}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'videoikon',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'Videominiaturebillede',
  'dynamic-cards-search-page.work-item-assignee.assigned': 'er tildelt',
  'dynamic-cards-search-page.work-item-creator.created': 'oprettede',
  'dynamic-cards-search-page.work-item-status.for': 'for',
  'dynamic-cards-search-page.work-item-ticket.label': 'Supportanmodning',
  'dynamic-cards-search-page.work-item.label': 'Sag',
  'initialsAvatar.label': 'Avatar med initialer',
  'personAvatar.label': 'Personavatar',
  'search-page.results.private-result-label': 'Privat',
  'search-page.results.private-result-tooltip': 'Kun synligt for dig',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmer}}',
  'search-page.results.product-results.third-party.channel-type-label': 'Kanal',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'Kanal',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, one {{count,number} medlem} other {{count,number} medlemmer}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    'Senest aktiv den {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': 'ukendt-kanal',
  'search-page.results.product-results.third-party.external-people-label': 'Eksterne personer',
  'search-page.results.product-results.third-party.external-person-label': 'Ekstern person',
  'search-page.results.product-results.third-party.last-active': 'Senest aktiv den {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'Besked',
  'search-page.results.product-results.third-party.no-contributors-label': 'Eksterne personer i #{channelName}',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} i en privat samtale',
  'search-page.results.product-results.third-party.thread-type-label': 'Tråd',
  'search-page.results.product-results.third-party.title-and-channel-name': '{title} i #{channelName}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, one {{title} og {remainingContributorsCount} anden} other {{title} og {remainingContributorsCount} andre}}',
  'search-page.results.restricted-result-label': 'Begrænset',
  'search-page.results.restricted-result-tooltip': 'Kun synligt for bestemte personer',
  'search-page.show-more-breadcrumbs-button-label': 'Vis flere breadcrumbs',
  'search-page.verified-icon-label': 'Verificeret',
  'search-page.verified-icon-tooltip-message': 'Denne side er blevet bekræftet af en ejer eller administrator.',
  'search-result.result.count': '{count, plural, one {Viser {count} resultat} other {Viser {count} resultater}}',
  'search-result.user-mention.external-person': 'Ekstern person',
};
